import ZoomBlueSvg from 'src/assets/images/zoom-blue.svg';
import styled from 'styled-components';

export const ZoomBlue = styled(ZoomBlueSvg)`
  max-height: 6rem;
  max-width: 100%;
`;
